import * as _swal from "sweetalert"
import { delay } from "./async";

const swal = _swal as any;
/**Muestra un cuadro de dialogo de si y no */
export async function yesno(title: string, text?: string, type?: "warning" | "error" | "success" | "info") {
    const result = await swal({
        buttons: true as any,
        closeOnClickOutside: true,
        closeOnEsc: true,
        title: title,
        icon: type,
        text: text,
    })

    //Nos esperamos a que se cierre por completo, esto porque si no al poner varios dialogos seguidos el evento del mouse de uno se toma tambien para el otro
    await delay(200);
    return result;
}

/**Muestra un cuadro de dialogo con un mensaje */
export async function message(title: string, text?: string, type?: "warning" | "error" | "success" | "info") {
    await swal({
        closeOnClickOutside: true,
        closeOnEsc: true,
        title: title,
        icon: type,
        text: text,
    })

    await delay(200);
}


// WEBPACK FOOTER //
// ./~/kea-react/src/dialogs.tsx